const plans = [
  {
    name: "1R〜1Kのお部屋",
    price: "50,000",
    desc: "ワンルームのゴミ屋敷清掃におすすめ。搬出・消臭・簡易清掃込みです。",
    size: "1〜2日程度",
    badge: "単身向け",
    highlight: false,
  },
  {
    name: "1LDK〜2LDK",
    price: "100,000",
    desc: "ファミリー向けのゴミ屋敷清掃に。堆積ゴミの搬出から除菌まで対応します。",
    size: "2〜3日程度",
    badge: "人気No.1",
    highlight: true,
  },
  {
    name: "3LDK・一軒家",
    price: "150,000",
    desc: "一軒家のゴミ屋敷清掃に。大量の堆積ゴミもスタッフが一気に片付けます。",
    size: "3〜5日程度",
    badge: "ご実家向け",
    highlight: false,
  },
  {
    name: "一軒家・敷地全体",
    price: "200,000",
    desc: "大きな一軒家や庭・倉庫まで含む広範囲の清掃に。原状回復レベルまで対応します。",
    size: "5日〜2週間程度",
    badge: "まるごと向け",
    highlight: false,
  },
];

const includedItems = [
  "スタッフの人件費",
  "堆積ゴミの搬出",
  "分別・積み込み",
  "処分費",
  "消臭・簡易清掃",
];

export default function Pricing() {
  return (
    <section id="pricing" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            PRICE
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            ゴミ屋敷清掃の<span className="text-primary-500">料金目安</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            お部屋の広さや堆積ゴミの量に合わせてお選びいただける、わかりやすい定額プランです。すべて税込・見積無料。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {plans.map((p) => (
            <div
              key={p.name}
              className={`relative rounded-lg border p-6 md:p-7 ${
                p.highlight
                  ? "bg-primary-500 text-background-50 border-primary-500"
                  : "bg-background-50 border-background-200"
              }`}
            >
              <span
                className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold tracking-widest mb-4 whitespace-nowrap ${
                  p.highlight
                    ? "bg-background-50 text-primary-600"
                    : "bg-accent-500 text-background-50"
                }`}
              >
                {p.badge}
              </span>
              <h3
                className={`text-base md:text-lg font-bold mb-4 ${
                  p.highlight ? "text-background-50" : "text-foreground-900"
                }`}
              >
                {p.name}
              </h3>
              <div className="flex items-baseline gap-x-1 gap-y-1 mb-4">
                <span
                  className={`font-heading font-bold text-4xl md:text-5xl leading-none tracking-tight ${
                    p.highlight ? "text-background-50" : "text-primary-600"
                  }`}
                >
                  {p.price}
                </span>
                <span
                  className={`font-heading font-bold text-xl leading-none ${
                    p.highlight ? "text-background-50" : "text-primary-600"
                  }`}
                >
                  円〜
                </span>
                <span
                  className={`text-xs ml-1 ${
                    p.highlight ? "text-background-50/80" : "text-foreground-500"
                  }`}
                >
                  （税込）
                </span>
              </div>
              <p
                className={`text-sm leading-relaxed ${
                  p.highlight ? "text-background-50/90" : "text-foreground-600"
                }`}
              >
                {p.desc}
              </p>
              <div
                className={`mt-4 pt-4 border-t ${
                  p.highlight ? "border-background-50/25" : "border-background-200"
                }`}
              >
                <p
                  className={`text-[11px] font-bold tracking-widest mb-1.5 ${
                    p.highlight ? "text-background-50/70" : "text-foreground-500"
                  }`}
                >
                  作業時間の目安
                </p>
                <p
                  className={`text-sm font-medium leading-relaxed ${
                    p.highlight ? "text-background-50" : "text-foreground-800"
                  }`}
                >
                  {p.size}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* ========== 料金に含まれる内容 ========== */}
        <div className="mt-10 md:mt-12 rounded-lg border border-secondary-200 bg-background-100 p-6 md:p-8">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-11 h-11 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 shrink-0">
              <i className="ri-check-double-line text-xl"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-foreground-900">
              料金に含まれる内容
            </h3>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed mb-5">
            すべてのプランに、以下の内容が含まれています。お見積り後の追加料金は一切ありません。
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
            {includedItems.map((item) => (
              <div
                key={item}
                className="flex items-center gap-2 rounded-md bg-background-50 border border-background-200 px-3.5 py-2.5"
              >
                <span className="w-4 h-4 flex items-center justify-center text-primary-600 shrink-0">
                  <i className="ri-checkbox-circle-fill text-sm"></i>
                </span>
                <span className="text-sm text-foreground-800 whitespace-nowrap">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-8 text-center text-xs md:text-sm text-foreground-500 leading-relaxed max-w-3xl mx-auto">
          ※堆積ゴミの量・部屋数・搬出状況・害虫駆除の有無などにより料金が変動する場合があります。害虫駆除・原状回復工事は別途料金がかかる場合があります。詳しくはお見積り時にご案内いたします。
        </p>
      </div>
    </section>
  );
}